import { colors } from '../../tokens';
export default {
  primary: {
    container: {
      width: '100%',
      padding: '16px'
    },
    labelColor: {
      color: colors.brand.primary
    },
    contentColor: {
      color: colors.dark
    }
  },
  "default": {
    container: {
      width: '100%',
      padding: '16px'
    },
    labelColor: {
      color: colors.grey[500]
    },
    contentColor: {
      color: colors.dark
    }
  }
};